import { useCallback, useState } from 'react';

import { ERRORS } from '../constants';
import { addCaptchaChallengeClass } from '../helpers';
import { useRecaptchaScale } from './useRecaptchaScale';
import { useValidateChallengeAnswer } from './useValidateChallengeAnswer';

export const useRenderRecaptcha = ({ onValidate, onError, operation, theme, size, tabIndex, captchaRef, language }) => {
    const [widgetId, setWidgetId] = useState();
    const recaptchaScale = useRecaptchaScale(captchaRef);
    const validateToken = useValidateChallengeAnswer({ onValidate, onError, operation, widgetId });

    return useCallback((publicKey) => {
        const { grecaptcha } = window;

        if (widgetId != null) {
            grecaptcha.reset(widgetId);
        }

        const newWidgetId = grecaptcha.render(captchaRef.current, {
            size,
            theme,
            hl: language,
            tabindex: tabIndex,
            sitekey: publicKey,
            callback: token => validateToken({ token }),
            'error-callback': () => onError(ERRORS.RE_CAPTCHA_ANY_ERROR),
            'expired-callback': () => onError(ERRORS.RE_CAPTCHA_EXPIRATION_ERROR)
        });

        setWidgetId(newWidgetId);

        addCaptchaChallengeClass();
        recaptchaScale();
    }, [recaptchaScale, validateToken, onError, theme, size, tabIndex, captchaRef, widgetId, language]);
};
